import CloseOutlined from "@mui/icons-material/CloseOutlined"
import {
	CircularProgress,
	Drawer,
	Grid,
	IconButton,
	Typography,
} from "@mui/material"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

import { AppDispatch, RootState } from "../../../store"
import {
	getPlickDetail,
	PlickResponse,
} from "../../../store/actions/plick-detail"
import PlickDrawerForm from "./form"
import { PlickState } from "../../../store/actions/file-detail"

const PlickDrawer = ({
	currentPlick,
	isDrawerOpen,
	setIsDrawerOpen,
}: {
	currentPlick: PlickState | undefined
	isDrawerOpen: boolean
	setIsDrawerOpen: (bool: boolean) => void
}) => {
	const dispatch = useDispatch<AppDispatch>()
	const { t } = useTranslation()
	const detailLoadingState: boolean = useSelector(
		(state: RootState) => state.plickDetail?.loading
	)
	const detailPlickState: PlickResponse | undefined = useSelector(
		(state: RootState) => state.plickDetail?.data
	)
	const bankSelectedId: number | undefined = useSelector(
		(state: RootState) => state.banksPaginated?.selected?.bankId
	)

	const [isSavable, setIsSavable] = useState<boolean>(false)

	useEffect(() => {
		if (!!currentPlick && bankSelectedId) {
			dispatch(
				getPlickDetail({
					bankId: bankSelectedId,
					fileId: currentPlick?.fileId,
					plickId: currentPlick?.id,
				})
			)
				.then(() => {})
				.catch(() => {})
		}
	}, [bankSelectedId, currentPlick])

	return detailLoadingState ? (
		<Grid item xs={12} sx={{ textAlign: "center" }}>
			<CircularProgress size={32} sx={{}} />
		</Grid>
	) : (
		<Drawer
			anchor="right"
			open={isDrawerOpen}
			onClose={() => setIsDrawerOpen(false)}
		>
			<Grid p={2} container justifyContent={"space-between"}>
				<Grid item flexGrow={1}>
					<Typography component="span" variant="h6">
						{`Transazione ${currentPlick?.transactionId} - ${currentPlick?.causal}`}
					</Typography>
				</Grid>
				<Grid item>
					<IconButton
						onClick={() => setIsDrawerOpen(false)}
						sx={{ width: "30px", height: "30px" }}
					>
						<CloseOutlined />
					</IconButton>
				</Grid>
			</Grid>

			<PlickDrawerForm
				currentPlick={detailPlickState ?? currentPlick}
				isSavable={isSavable}
				setIsSavable={setIsSavable}
				setIsDrawerOpen={setIsDrawerOpen}
			/>
		</Drawer>
	)
}

export default PlickDrawer
